import axios from "axios";
import { APICLIENT } from "../shared/index";
import { apiendpoints } from "../constants/api-endpoints";


// ********GET_REWARDS ***********
export const getRewards = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_REWARDS);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};


//******* GET REWARDS DETAILS  *********
export const getRewardsDetails = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
      const response = await axioClient.post(apiendpoints.GET_REWARDS_DETAILS, data);
      const res = APICLIENT.handleResponse(response);
      return res;
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


  
//******* GET CLAIM REWARDS   *********
export const getClaimRewards= async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
      const response = await axioClient.post(apiendpoints.CLAIM_REWARDS, data);
      const res = APICLIENT.handleResponse(response);
      return res;
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


  //******* GET GIFT REWARDS   *********
export const getGiftRewards= async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
      const response = await axioClient.post(apiendpoints.GIFT_REWARDS, data);
      const res = APICLIENT.handleResponse(response);
      return res;
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


  // ******** MY_REWARDS ***********
export const getMyRewards = async () => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(apiendpoints.MY_REWARDS);
      return APICLIENT.handleResponse(response);
    } catch (error) {
      return APICLIENT.handleError(error);
    }
  };


    // ******** MY_REWARDS ***********
export const getBookingsList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.BOOKINGS);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};

    // ******** Get_Content ***********
    export const getContentList = async () => {
      try {
        const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
        const response = await axioClient.get(apiendpoints.CONTENT_API);
        return APICLIENT.handleResponse(response);
      } catch (error) {
        return APICLIENT.handleError(error);
      }
    };